import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { useRestaurantData } from '../hooks/useRestaurantData';
import './Hero.css';

const Hero = () => {
    const [current, setCurrent] = useState(0);
    const data = useRestaurantData();
    const slides = data.heroSlides;

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    return (
        <div className="hero">
            <AnimatePresence mode='wait'>
                <motion.div
                    key={current}
                    initial={{ opacity: 0, scale: 1.1 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1 }}
                    className="hero-slide"
                >
                    <div
                        className="hero-bg"
                        style={{ backgroundImage: `url(${slides[current].image})` }}
                    >
                        <div className="hero-overlay" />
                    </div>

                    <div className="hero-content container">
                        <motion.h1
                            initial={{ x: -50, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.8 }}
                            className="hero-title"
                        >
                            {slides[current].title}
                        </motion.h1>
                        <motion.p
                            initial={{ x: -30, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.7, duration: 0.8 }}
                            className="hero-subtitle"
                        >
                            {slides[current].subtitle}
                        </motion.p>
                        <motion.button
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.9, duration: 0.8 }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' })}
                            className="hero-cta"
                        >
                            Voir la carte
                            <ChevronRight />
                        </motion.button>
                    </div>
                </motion.div>
            </AnimatePresence>

            <div className="hero-pagination">
                {slides.map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => setCurrent(idx)}
                        className={`pagination-dot ${idx === current ? 'pagination-dot-active' : 'pagination-dot-inactive'}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Hero;
